var deploymentStatusInterval = null;
var deploymentNotificationId = null;
var versionCheckInterval = null;
var appVersion = null;
var originalFetch = window.fetch;

// Helper function to get translations with fallback
function getTranslation(key) {
    return window.deploymentTranslations?.[key] || key;
}

function getFetchUrl(input) {
    if (typeof Request !== 'undefined' && input instanceof Request) {
        return input.url;
    }

    return String(input ?? '');
}

window.fetch = function (...args) {
    return originalFetch.apply(this, args).then(response => {
        if (!window.FilamentNotification) {
            return response;
        }

        const isLivewireRequest = getFetchUrl(args[0]).includes('livewire');
        if (!isLivewireRequest) {
            return response;
        }

        const isDeploymentError = response?.status === 502 || response?.status === 503;
        if (isDeploymentError) {
            new FilamentNotification()
                .title(getTranslation('System Update in Progress'))
                .body(getTranslation('The system is being updated. Please wait a moment...'))
                .warning()
                .send();

            monitorDeploymentStatus();

            return response;
        }

        const isServerError = response?.status === 500;
        if (isServerError) {
            new FilamentNotification()
                .title(getTranslation('Oops!'))
                .body(getTranslation('Please try again in a moment - we are on it!'))
                .danger()
                .actions([
                    new FilamentNotificationAction('refresh')
                        .label(getTranslation('Refresh'))
                        .button()
                        .url(window.location.href),
                ])
                .send();

            return response;
        }

        const isSessionExpired = response?.status === 419;
        if (isSessionExpired) {
            new FilamentNotification()
                .title(getTranslation('Session Expired'))
                .body(getTranslation('Your session has expired. Please refresh to continue.'))
                .warning()
                .actions([
                    new FilamentNotificationAction('refresh')
                        .label(getTranslation('Refresh'))
                        .button()
                        .url(window.location.href),
                ])
                .send();

            return response;
        }

        return response;
    });
};

function monitorDeploymentStatus() {
    if (deploymentStatusInterval) {
        return;
    }

    deploymentStatusInterval = setInterval(async () => {
        try {
            var response = await fetch('/up');

            if (!response.ok) {
                return;
            }

            clearInterval(deploymentStatusInterval);

            if (!window.FilamentNotification) {
                return;
            }

            new FilamentNotification()
                .title(getTranslation('Update Complete'))
                .body(getTranslation('The system has been updated. Click to refresh.'))
                .success()
                .persistent()
                .actions([
                    new FilamentNotificationAction('refresh')
                        .label(getTranslation('Refresh'))
                        .button()
                        .url(window.location.href),
                ])
                .send();
        } catch {
            return;
        }
    }, 6000);
}

async function initializeVersionCheck() {
    // the baseline is the version of the server that RENDERED this page, stamped into the layout.
    // it deliberately does not come from a first /up call: the HTML and that call are two
    // independent requests through the load balancer, so mid-rolling-deploy the page can come
    // from the old box while /up answers from the new one — adopting that as the baseline makes a
    // tab running dead assets never see a mismatch, which is the case this whole check exists for.
    if (window.appVersion) {
        appVersion = window.appVersion;

        startVersionCheck();

        return;
    }

    // layouts that do not stamp it fall back to whichever version /up answers with
    try {
        var response = await fetch('/up');

        if (!response.ok) {
            return;
        }

        var data = await response.json();
        appVersion = data.version;

        // start checking for version changes every 5 minutes
        startVersionCheck();
    } catch (error) {
        // silently fail if version check initialization fails
        console.error('Failed to initialize version check:', error);
    }
}

function startVersionCheck() {
    if (versionCheckInterval) {
        return;
    }

    versionCheckInterval = setInterval(
        async () => {
            try {
                var response = await fetch('/up');

                if (!response.ok) {
                    return;
                }

                var data = await response.json();

                if (appVersion && data.version !== appVersion) {
                    clearInterval(versionCheckInterval);
                    showVersionUpdateNotification();
                }
            } catch (error) {
                // silently fail if version check fails
                console.error('Version check failed:', error);
            }
        },
        5 * 60 * 1000
    ); // check every 5 minutes
}

function showVersionUpdateNotification() {
    if (!window.FilamentNotification) {
        return;
    }

    new FilamentNotification()
        .title(getTranslation('New Version Available'))
        .body(getTranslation('Refresh to get the latest version of the app'))
        .info()
        .persistent()
        .actions([
            new FilamentNotificationAction('refresh')
                .label(getTranslation('Refresh'))
                .button()
                .url(window.location.href),
        ])
        .send();
}

// initialize version checking on page load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeVersionCheck);
} else {
    initializeVersionCheck();
}
